import { render } from "./CustomerReviews.vue?vue&type=template&id=75403bd3&scoped=true"
import script from "./CustomerReviews.vue?vue&type=script&lang=js"
export * from "./CustomerReviews.vue?vue&type=script&lang=js"

import "./CustomerReviews.vue?vue&type=style&index=0&id=75403bd3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75403bd3"]])

export default __exports__